module.exports = __webpack_public_path__ + "static/media/ICBT 31T Drive.05abe30b.jpg";